import { c as _c } from "react/compiler-runtime";
import { Field, FieldContent, FieldDescription, FieldError, FieldLabel, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps, ReactNode } from 'react';
import { ReadOnlyField, useReadOnly } from '../../components/readonly.tsx';
import { useFieldContext } from '../../lib/form-context.ts';
const BILL_CATEGORY_OPTIONS = [{
  label: 'Carrier bill',
  value: 'carrier'
}, {
  label: 'Customs',
  value: 'customs'
}, {
  label: 'Other',
  value: 'other'
}] as const;
export const FormBillCategorySelect = t0 => {
  const $ = _c(48);
  const {
    "data-testid": dataTestId,
    description,
    disabled: t1,
    isPending: t2,
    label,
    options,
    placeholder: t3,
    required,
    variant: t4
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const isPending = t2 === undefined ? false : t2;
  const placeholder = t3 === undefined ? "-" : t3;
  const variant = t4 === undefined ? "default" : t4;
  const field = useFieldContext();
  const isReadOnly = useReadOnly();
  const isCompact = variant === "ghost" || variant === "no-style";
  const resolvedOptions = options ?? BILL_CATEGORY_OPTIONS;
  let t5;
  if ($[0] !== field || $[1] !== label || $[2] !== required) {
    t5 = label && typeof label === "string" ? <FieldLabel className={cn(required && "required gap-0.5")} htmlFor={field.name}>{label}</FieldLabel> : label;
    $[0] = field;
    $[1] = label;
    $[2] = required;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const fieldLabel = t5;
  if (isReadOnly) {
    let t6;
    if ($[4] !== field || $[5] !== resolvedOptions) {
      t6 = resolvedOptions.find(option => option.value === field.state.value)?.label ?? "-";
      $[4] = field;
      $[5] = resolvedOptions;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== fieldLabel || $[8] !== t6) {
      t7 = <ReadOnlyField label={fieldLabel}>{t6}</ReadOnlyField>;
      $[7] = fieldLabel;
      $[8] = t6;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    return t7;
  }
  const t6 = disabled || isPending;
  let t7;
  if ($[10] !== field) {
    t7 = val => field.handleChange(val);
    $[10] = field;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = field.state.value;
  const t9 = isCompact && "p-0 text-base data-[size=default]:h-6";
  let t10;
  if ($[12] !== t9) {
    t10 = cn("w-full justify-between gap-2", t9);
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = dataTestId ?? "form-bill-category-select-trigger";
  let t12;
  if ($[14] !== placeholder) {
    t12 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="form-bill-category-select.tsx" />;
    $[14] = placeholder;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== isPending) {
    t13 = isPending && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[16] = isPending;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== field.name || $[19] !== isCompact || $[20] !== t10 || $[21] !== t11 || $[22] !== t12 || $[23] !== t13 || $[24] !== variant) {
    t14 = <SelectTrigger className={t10} data-testid={t11} hideChevron={isCompact} id={field.name} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="form-bill-category-select.tsx">{t12}{t13}</SelectTrigger>;
    $[18] = field.name;
    $[19] = isCompact;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = variant;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== resolvedOptions) {
    t15 = resolvedOptions.map(_temp);
    $[26] = resolvedOptions;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15) {
    t16 = <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="form-bill-category-select.tsx">{t15}</SelectContent>;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== field.state.value || $[31] !== resolvedOptions || $[32] !== t14 || $[33] !== t16 || $[34] !== t6 || $[35] !== t7) {
    t17 = <div className="relative"><Select disabled={t6} items={resolvedOptions} onValueChange={t7} value={t8} data-sentry-element="Select" data-sentry-source-file="form-bill-category-select.tsx">{t14}{t16}</Select></div>;
    $[30] = field.state.value;
    $[31] = resolvedOptions;
    $[32] = t14;
    $[33] = t16;
    $[34] = t6;
    $[35] = t7;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== description) {
    t18 = description && typeof description === "string" ? <FieldDescription>{description}</FieldDescription> : description;
    $[37] = description;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== fieldLabel || $[40] !== t17 || $[41] !== t18) {
    t19 = <FieldContent data-sentry-element="FieldContent" data-sentry-source-file="form-bill-category-select.tsx">{fieldLabel}{t17}{t18}</FieldContent>;
    $[39] = fieldLabel;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== field.state.meta.errors) {
    t20 = <FieldError className="text-sm" errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-bill-category-select.tsx" />;
    $[43] = field.state.meta.errors;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19 || $[46] !== t20) {
    t21 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormBillCategorySelect" data-sentry-source-file="form-bill-category-select.tsx">{t19}{t20}</Field>;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  return t21;
};
function _temp(category) {
  return <SelectItem data-testid={`form-bill-category-select-option-${category.value}`} key={category.value} value={category.value}>{category.label}</SelectItem>;
}